import { STATUS_CODES } from 'utils/Constants'
import ErrorPage from 'components/error/ErrorPage'
import SimpleErrorPage from 'components/error/SimpleErrorPage'

type ErrorProps = {
  errorCode?: number
}

const Error = ({ errorCode }: ErrorProps) => {
  const { CODE200, CODE404, CODE500 } = STATUS_CODES
  switch (errorCode) {
    case CODE200:
      return null
    case CODE404:
      return <ErrorPage errorCode={errorCode} />
    case CODE500:
    default:
      return <SimpleErrorPage />
  }
}

export default Error
